import React from 'react';
import { Helmet } from 'react-helmet';
import { getEnvVariable } from '../envHelper';

const AfitdPageHead = props => {
    const { title, noSiteNameInTitle, description, keywords, canonicalUrl } = props;
    const siteName = getEnvVariable('AFITD_SITE_NAME');

    const pageTitle = title ? (noSiteNameInTitle ? title : `${title} | ${siteName}`) : siteName;

    const headTagList = [];
    headTagList.push(<title>{pageTitle}</title>);
    description && headTagList.push(<meta name="description" content={description} />);
    keywords && headTagList.push(<meta name="keywords" content={keywords} />);
    canonicalUrl && headTagList.push(<link rel="canonical" href={canonicalUrl} />);

    return <Helmet>{headTagList}</Helmet>;
};

export default AfitdPageHead;
